var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1703 4.375H5.82969C5.44476 4.37786 5.07641 4.53205 4.80423 4.80423C4.53205 5.07641 4.37786 5.44476 4.375 5.82969V29.1703C4.37786 29.5552 4.53205 29.9235 4.80423 30.1958C5.07641 30.4679 5.44476 30.6221 5.82969 30.625H18.3969V20.475H14.9844V16.5047H18.3969V13.5844C18.3969 10.1937 20.4641 8.34531 23.5047 8.34531C24.5219 8.34531 25.5391 8.34531 26.5562 8.49844V12.0312H24.4672C22.8156 12.0312 22.4984 12.8188 22.4984 13.9672V16.4938H26.4359L25.9219 20.4641H22.4984V30.625H29.1703C29.5552 30.6221 29.9235 30.4679 30.1958 30.1958C30.4679 29.9235 30.6221 29.5552 30.625 29.1703V5.82969C30.6221 5.44476 30.4679 5.07641 30.1958 4.80423C29.9235 4.53205 29.5552 4.37786 29.1703 4.375Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.dcf51a2fcbd81a30498df7489ff8e894.svg";
export { ForwardRef as ReactComponent };